export function pathRewrite(pathRewriteObj, url) {
  if (pathRewriteObj && Object.keys(pathRewriteObj).length) {
    Object.keys(pathRewriteObj).find(ele => {
      const regExp = new RegExp(ele);
      if (regExp.test(url)) {
        url = url.replace(regExp, pathRewriteObj[ele]);
        return true;
      } else {
        return false;
      }
    });
  }
  return url;
}
export function trim(params) {
  if (params instanceof Object) {
    Object.keys(params).forEach(ele => {
      if (typeof params[ele] == 'string') {
        params[ele] = params[ele].replace(/(^\s*)|(\s*$)/g, '');
      }
    });
  }
  return params;
}
// // 设置用户信息
// export function userInfo(info) {
//   if(info){
//     const { sessionId,name} = info;
//     if(sessionId || sessionId===''){
//       localStorage.setItem('settlementCenterToken',sessionId);
//     }
    
//     if(name || name===''){
//       localStorage.setItem('settlementCenterName',name);
//     }
//   }
//   return {
//     sessionId:localStorage.getItem('settlementCenterToken'),
//     name:localStorage.getItem('settlementCenterName'),
//   };
// }
// 删除路径中中，指定的参数名
export function delParam({
  key,
  url,
}) {
  const urlParam = url.substr(url.indexOf('?')); //页面参数
  const beforeUrl = url.substr(0, url.indexOf('?')); //页面主地址（参数之前地址）
  let nextUrl = '';
  const arr = new Array();
  if (urlParam != '') {
    const urlParamArr = urlParam.split('&'); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      const paramArr = urlParamArr[i].split('='); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (Array.isArray(key)){
        if (!key.includes(paramArr[0])){
          arr.push(urlParamArr[i]);
        }
      } else {
        if (paramArr[0] != key) {
          arr.push(urlParamArr[i]);
        }
      }
      
    }
  }
  if (arr.length > 0) {
    nextUrl = `?${ arr.join('&')}`;
  }
  url = beforeUrl + nextUrl;
  return url;
}
export default {
  pathRewrite,
  trim,
  // userInfo,
  delParam,
};
